import * as React from 'react';

const defaultColumnContextValue = { breakpointSize: 'mc', columnSpan: 3, maxColumns: 3, tag: 'div' };
export type TColumnContext = Partial<typeof defaultColumnContextValue>;

const ColumnContext = React.createContext<TColumnContext>(defaultColumnContextValue);

export { ColumnContext, defaultColumnContextValue };
